import api from '../../api';
import sideBar from '../sidebar';

const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const controlPanel = (() => {
    return function () {
        let steps = [{
            element: '#user-actions',
            title: 'Opções do Usuário',
            content: 'Clique neste botão para acessar algumas opções pertinentes ao usuário.',
            placement: 'right',
            onShow () {
                return sideBar.open();
            }
        }];

        if (isAuthorized('control-panel-users')) {
            steps.push({
                element: '#control-panel',
                title: 'Painel de Controle',
                content: 'O painel de controle permite adicionar novos usuários, editar usuários existente ou excluí-los.',
                placement: 'right',
                onShow () {
                    sideBar.open();
                    return setTimeout(() => {
                        if (!$('#user-actions').closest('.dropdown').hasClass('.open')) {
                            $('#user-actions').trigger('click');
                        }
                    }, 1000);
                }
            });
        }

        steps = steps.concat([{
            element: '#change-password',
            title: 'Alterar Senha',
            content: 'Clique nesta opção para alterar sua senha.',
            placement: 'right',
            onShow () {
                sideBar.open();
                return setTimeout(() => {
                    if (!$('#user-actions').closest('.dropdown').hasClass('.open')) {
                        $('#user-actions').trigger('click');
                    }
                }, 1000);
            }
        }, {
            element: '#user-signout',
            title: 'Logout',
            content: 'Para sair do sistema basta clicar nesta opção.',
            placement: 'right',
            onShow () {
                sideBar.open();
                return setTimeout(() => {
                    if (!$('#user-actions').closest('.dropdown').hasClass('.open')) {
                        $('#user-actions').trigger('click');
                    }
                }, 1000);
            }
        }]);
        return steps;
    };
})();

export default controlPanel;



// WEBPACK FOOTER //
// ./src/scripts/core/tour/control-panel.js